import {useTranslation} from "react-i18next";
import useTitleAndDescription from "../common/hooks/useTitleAndDescription";
import {Footer, Header} from "../components/common";
import {ErrorBoundary} from "react-error-boundary";
import React from "react";
import BottomStickAd from "../components/ad/BottomStickAd";
import styled from "styled-components";
import CenterBox from "../components/common/CenterBox";

function Fallback({error, resetErrorBoundary}) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.

    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
        </div>
    );
}


const Wrapper = styled.div`
`;

const ContentWrapper = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ImageBox = styled.div`
    margin-top: 92px;
  cursor: pointer;
`;
const Tracker = () => {
    const {t} = useTranslation();
    useTitleAndDescription({
        title: '커스텀트래커  | DEEPLOL.GG',
        description: '2025 SOOP SLL SUMMER 대회에 참가한 스트리머들의 스크림 경기와 AI-SCORE를 한눈에 확인하세요!',
    })
    return (
        <Wrapper>
            <Header/>
            <ContentWrapper>
                <ErrorBoundary FallbackComponent={Fallback}>
                    <CenterBox disableSponsor={true} disableBottomAd={true}>
                        <ImageBox onClick={() => window.open('https://tally.so/r/nG71ap',"_blank", "noreferrer")}>
                            <img src={'/images/image_custom_tracker.png'} alt={''}/>
                        </ImageBox>
                    </CenterBox>
                </ErrorBoundary>
            </ContentWrapper>
            <Footer/>
            <BottomStickAd/>
        </Wrapper>
    );
};
export default Tracker